"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBandaidFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M11.41 3.646l8.939 8.89c1.767 1.767 2.475 5.302 0 7.777-2.475 2.475-6.046 1.804-7.779 0l-8.938-8.889c-1.766-1.764-2.472-5.3.002-7.776 2.475-2.475 6.01-1.768 7.776-.002zM4.993 5.117C3.58 6.532 3.708 8.667 5.2 10.16c.025.025 4.937-4.958 4.937-4.958C8.655 3.72 6.535 3.576 5.12 4.99c-1.414 1.414 1.287-1.288-.127.126v.001zm8.691 13.528c1.376 1.376 3.718 1.786 5.132.372 1.415-1.414-1.255 1.256.159-.158s1.034-3.786-.342-5.162l-4.949 4.948zm-1.406-8.493a.999.999 0 00-.708-1.707 1 1 0 10.708 1.707zm-2.122 2.122a1 1 0 10-1.389-1.438 1 1 0 001.389 1.438zm4.95.707a1 1 0 10-1.389-1.438 1 1 0 001.389 1.438zm-2.121 2.121a1 1 0 10-1.415-1.414 1 1 0 001.415 1.414z' }))); };
exports.default = SvgBandaidFilled;
//# sourceMappingURL=BandaidFilled.js.map